import { createArrayIntentType, getIntents } from '../intent';
const configIntentTypes = new WeakMap();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withViewConfig(config, intents) {
    let intentType = configIntentTypes.get(config);
    if (!intentType) {
        intentType = createArrayIntentType('withConfig', (decorate)=>(intents)=>decorate(intents));
        configIntentTypes.set(config, intentType);
    }
    return intentType(intents);
}
export function isViewConfigIntent(revision, intent) {
    const intentType = configIntentTypes.get(revision.instance.config);
    if (intentType) {
        return intentType.isIntent(intent);
    }
    return false;
}
export function getViewConfigIntents(forRevision, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fromRevision = forRevision) {
    const intentType = configIntentTypes.get(forRevision.instance.config);
    if (intentType) {
        return getIntents(intentType, fromRevision);
    }
}
export function getViewConfigIntentType(revision) {
    return configIntentTypes.get(revision.instance.config);
}

//# sourceMappingURL=ConfigIntent.js.map